module.exports = __webpack_public_path__ + "static/media/payment-american-express.e5035247.png";